module.exports = __webpack_public_path__ + "img/duo-tab-icon-active.a374ad02.svg";